var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('h1',[_vm._v("Component 2")]),_c('h3',[_vm._v("Access token")]),_c('p',[_vm._v(_vm._s(_vm.$route.query.access_token))]),_c('v-switch',{model:{value:(_vm.toggle),callback:function ($$v) {_vm.toggle=$$v},expression:"toggle"}}),_c('p',[_vm._v(_vm._s(_vm.number))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }